import { isLocalDev } from '@/constants/envs'
import { axiosInstance } from './axiosConfig'
import { devLog } from './devLog'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'
import { KEEP_SESSION_ALIVE_INTERVAL_MS } from '@constants/session'

const KEEP_ALIVE_STORAGE_KEY = 'keepAliveLastSent'
const KEEP_ALIVE_THROTTLE_MS = KEEP_SESSION_ALIVE_INTERVAL_MS / 2

export const keepAlive = () => {
  if (isLocalDev) return
  if (window.location.pathname.includes('error')) return

  try {
    const now = Date.now()
    const last = Number(localStorage.getItem(KEEP_ALIVE_STORAGE_KEY) ?? 0)
    const elapsed = now - last
    if (elapsed >= 0 && elapsed < KEEP_ALIVE_THROTTLE_MS) return
    localStorage.setItem(KEEP_ALIVE_STORAGE_KEY, String(now))
  } catch (e) {
    devLog(e)
  }

  axiosInstance
    .post(`${API_URL}/${ONBOARDING_SERVICE_PATH}/heartbeat`, {}, { withCredentials: true })
    .catch((e) => devLog(e))
}
